import React, { useCallback, useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import { Modal } from '~/components';
import { FormGroup } from '~/components/form';
import { useForm, useRouter } from '~/hooks';
import { verifyFileNumber as verifyFileNumberApi, overlayTitleOpinion as overlayTitleOpinionApi } from '~/api/titleOpinion';
import { dataFieldsToDuplicate } from '~/util';

/** @type {FileNumberPopup} */
const defaultState = {
    filenumber: '',
};

const loadData = async (values, props) => {  
    return {
        ...values,
        ...props 
    };
};

const FileNumberPopup = (props) => {
    const { isOpen, setOpen, titleOpinionId } = props;
    const [error, setError] = useState('');
    const { history } = useRouter();

    useEffect(() => {
        const handleKeypress = e => {
            if (e.key === 'Enter') {
                apply();
            }
        };
        document.addEventListener('keypress', handleKeypress);

        return () => document.removeEventListener('keypress', handleKeypress);
    }, []);

    const onLoad = useCallback((values, props) => {
        return loadData(values, props);
    }, [props.isOpen]);

    const { state, fieldActions } = useForm({
        initialState: { ...defaultState },
        props,
        onLoad,
        debug: true
    }); 

    const apply =async()=> {
        let fileNumber = state.values.filenumber;
        if(fileNumber == '') return;
        const result =  await verifyFileNumberApi(fileNumber);
        if(result == null || result == undefined || result == '') {
            setError("Incorrect File Number");
            return;
        }
        else {
            setError('');
        }

        const titleOpinionIdOriginal = result[0]?.id;
        const payload = {
            titleOpinionId,
            titleOpinionId_original: titleOpinionIdOriginal,
            dataToDuplicate: dataFieldsToDuplicate.PTO_DATA_FIELDS_DUPLICATE.dataToDuplicate
        };

        await overlayTitleOpinionApi(payload);
        history.push("/preliminaryopinion/" + titleOpinionId);
        setOpen(false);
    };

    return (    
        <Modal isModalOpen={isOpen} preventScroll className='rounded-md bg-white'>
            <section className='w-full h-full flex flex-col items-stretch justify-start'>
                <header className="border-b-2 text-sm flex items-center justify-between py-2 px-6">
                    <p className="font-semibold">Overlay Order</p>
                    <button 
                        className="py-2 rounded-full"
                        onClick={() => setOpen(false)}
                    >
                        <MdClose size="1em" />
                    </button>
                </header>
                <div className='flex items-center justify-center flex-1 p-6'>
                    <div className='grid grid-cols-11 gap-y-4'>
                        <FormGroup
                            inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                            labelClassName='text-sm'
                            groupClassName='col-span-5'
                            label='Your File Number'
                            path='filenumber'                
                            value={state.values.filenumber}
                            error={state.errors.filenumber}
                            {...fieldActions}
                        />
                        <p className='col-span-11 flex items-center justify-start text-lg text-red bg-red-50'>{error}</p>
                        <div className='col-span-11 flex items-center justify-end text-xs'>
                            <button 
                                className='py-2 px-4 rounded-full bg-blue-50 text-white focus:outline-none'
                                onClick={() => apply()}
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </Modal>
    );
};

export default FileNumberPopup;